import { TIME_PERIOD_FILTERS } from './FiltersConstants';
const {
  THIS_MONTH,
  THIS_QUARTER,
  THIS_YEAR,
  THIS_FISCAL_QUARTER,
  THIS_FISCAL_YEAR
} = TIME_PERIOD_FILTERS;
export const CATEGORY_OPTION = 'categoryOption';
export const DEAL_ROLLUP_OVER_TIME_RESPONSE = 'dealRollUpOverTimeResponse';
export const AGGREGATED_CLOSED_WON_CHANGE = 'aggregatedClosedWonChange';
export const AGGREGATED_SUBMISSION = 'aggregatedForecastOverTime';
export const CLOSED_WON = 'closedWon';
export const GAP = 'gap';
export const FORECAST_SUBMISSION = 'forecastSubmission';
export const WEEK_OVER_WEEK = 'weekOverWeek';
const CHANGE_INDICATOR_VISIBILITY_BY_TIME_PERIOD = {
  [CLOSED_WON]: {
    [WEEK_OVER_WEEK]: [THIS_MONTH, THIS_QUARTER, THIS_YEAR, THIS_FISCAL_QUARTER, THIS_FISCAL_YEAR]
  },
  [GAP]: {
    [WEEK_OVER_WEEK]: [THIS_MONTH, THIS_QUARTER, THIS_YEAR, THIS_FISCAL_QUARTER, THIS_FISCAL_YEAR]
  },
  [FORECAST_SUBMISSION]: {
    [WEEK_OVER_WEEK]: [THIS_MONTH, THIS_QUARTER, THIS_YEAR, THIS_FISCAL_QUARTER, THIS_FISCAL_YEAR]
  }
};
export const shouldFetchChangeIndicators = ({
  dataWell,
  comparisonFilter,
  timePeriod
}) => typeof timePeriod === 'string' && CHANGE_INDICATOR_VISIBILITY_BY_TIME_PERIOD[dataWell][comparisonFilter].includes(timePeriod);